<template>
  <div>
    <div class="centered-column">
      <div class="container-header">
        <h3>{{ label.get('web_time_clock') }}</h3>
      </div>

      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{label.get('preference')}}</label>
          </div>
        </div>
        <div class="toggle-dep no-border job-codes-toggle-dep">
          <div class="check-wrapper switch-wrapper job-codes-switch">
            <b-form-checkbox
                v-model="webTimeClock"
                @change="onChangeWebTimeClock"
            >
              {{ label.get('web_time_clock') }}
            </b-form-checkbox>
            <p class="disclaimer">
              {{ label.get('web_time_clock_description') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyService from "../company/services/CompanyService";

export default {
  name: "TimeClockComponent",
  data() {
    return {
      webTimeClock: this.$store.state.companySettings.web_timeclock === 1,
      debounce: null
    }
  },
  methods: {
    onChangeWebTimeClock() {
      const _this = this;
      this.$store.state.companySettings.web_timeclock = !_this.webTimeClock;
      if(_this.debounce) {
        clearTimeout(_this.debounce);
      }

      _this.debounce = setTimeout(() => {
        CompanyService.updateCompanySettings(_this.$store.state.companySettings).then(() => { }).catch(() => { });
      }, 1000);
    }
  }
}
</script>

<style scoped>

</style>